export default {
  placeholders: {
    delivery_zip_code: 'Código postal',
    delivery_city: 'Ciudad',
    delivery_street_number: 'Número de calle',
    delivery_street_name: 'Nombre de la calle',
    type_your_address: 'Escribe tu dirección',
  },
  errors: {
    address_suggestions_unavailable:
      'No se pudieron cargar las sugerencias de direcciones. Aún puedes introducir tu dirección abajo.',
  },
  buttons: {
    retry: 'Intentar de nuevo',
  },
};
